<template>
    <div>
        <v-dialog v-bind:value="value" scrollable persistent max-width="600px" transition="dialog-transition">
            <v-card>
                <v-img class="white--text" height="100px" src="https://cdn.vuetifyjs.com/images/cards/docks.jpg">
                    <v-container fill-height fluid>
                        <v-layout fill-height>
                            <v-flex xs12 align-end flexbox>
                                <span class="headline">{{$t("book.dialog.title")}}</span>
                                <br>
                                <span class="subheading">{{$t("book.dialog.subtitle")}}</span>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-img>
                <v-card-text>
                    <v-form>
                        <v-layout row wrap>
                            <v-flex xs12 sm6 md6 lg6 class="px-2">
                                <v-text-field v-model="customer.name" name="name" :label="$t('book.dialog.name')" id="name"
                                    :error-messages="nameErrors" @input="$v.customer.name.$touch()" @blur="$v.customer.name.$touch()"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6 lg6 class="px-2">
                                <v-text-field v-model="customer.surname" name="surname" :label="$t('book.dialog.surname')" id="surname"
                                    :error-messages="surnameErrors" @input="$v.customer.surname.$touch()" @blur="$v.customer.surname.$touch()"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 sm6 md6 lg6 class="px-2">
                                <v-text-field v-model="customer.email" name="email" label="E-mail*" id="email"
                                    :error-messages="emailErrors" @input="$v.customer.email.$touch()" @blur="$v.customer.email.$touch()"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6 lg6 class="px-2">
                                <v-text-field v-model="customer.phone" name="phone" placeholder="+393331212444" :label="$t('book.dialog.phone')" id="phone"
                                    ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md12 lg12 class="px-1">
                                <v-textarea v-model="message" auto-grow box color="deep-purple" :label="$t('book.dialog.message')" rows="1"></v-textarea>
                                <v-checkbox v-model="agreement" color="deep-purple">
                                    <template v-slot:label>
                                        {{$t('book.dialog.privacy1')}}&nbsp;
                                        <a href="#" @click.stop.prevent="dialogTerms = true">{{$t('book.dialog.terms')}}</a>
                                        &nbsp;{{$t('book.dialog.privacy2')}}&nbsp;
                                        <a href="#" @click.stop.prevent="dialogPrivacy = true">{{$t('book.dialog.privacy')}}</a>*
                                    </template>
                                </v-checkbox>
                            </v-flex>
                        </v-layout>
                    </v-form>
                    <!-- ROOMS SELECTED TO BE BOOKED -->
                    <v-layout row align-center justify-center>
                        <v-flex xs12 sm12 md12 lg12>
                            <v-chip color="indigo" text-color="white" v-for="(room, index) of rooms" :key="index">
                                <v-avatar>
                                    <v-icon>favorite</v-icon>
                                </v-avatar>
                                {{room.name}}
                            </v-chip>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="$emit('close')">{{$t('book.dialog.close')}}</v-btn>
                    <v-btn :disabled="!agreement" color="success" @click="tryBooking()">{{$t('book.dialog.send')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <dialog-terms v-model="dialogTerms" @close-terms="dialogTerms = false" />
        <dialog-privacy v-model="dialogPrivacy" @close-privacy="dialogPrivacy = false" />
    </div>
</template>

<script>
import Book from "../../../models/book";
import Customer from "../../../models/customer";
import DialogTerms from "./DialogTerms.vue";
import DialogPrivacy from "./DialogPrivacy.vue";
import { required, minLength, email } from 'vuelidate/lib/validators';

export default {
    components: { DialogTerms, DialogPrivacy },

    props: {
        value:{ 
            type: Boolean,
            required: true,
            default: false
        },
        rooms:{ 
            type: Array,
            required: true,
            default: []
        }
    },

    data(){
        return{
            book: new Book(),
            customer: new Customer("", "", "", ""),
            agreement: false,
            message: "",
            dialogTerms: false,
            dialogPrivacy: false
        }
    },
    methods: {
        tryBooking(){
            // Trigger validation
            this.$v.$touch();

            if (!this.$v.$invalid){
                this.book.customer = this.customer;
                this.book.message = this.message;
                
                this.$emit('try-booking', this.book);
            }else{
                this.$awn.alert(this.$t('book.dialog.errors.form_error'));
            }
        }
    },
    validations: {
        customer: {
            name: {
                required,
                minLength: minLength(3)
            },
            surname: {
                required,
                minLength: minLength(2)
            },
            email: {
                required,
                email
            }
        }
    },
    computed: {
        nameErrors(){
            const errors = [];
            
            if (!this.$v.customer.name.$dirty) 
                return errors;

            !this.$v.customer.name.minLength && errors.push(`${this.$t("book.dialog.errors.minLength")} ${this.$v.customer.name.$params.minLength.min}`);
            !this.$v.customer.name.required && errors.push(this.$t("book.dialog.errors.required"));
            
            return errors;
        },
        surnameErrors(){
            const errors = [];
            
            if (!this.$v.customer.surname.$dirty) 
                return errors;

            !this.$v.customer.surname.minLength && errors.push(`${this.$t("book.dialog.errors.minLength")} ${this.$v.customer.surname.$params.minLength.min}`);
            !this.$v.customer.surname.required && errors.push(this.$t("book.dialog.errors.required"));
            
            return errors;
        },
        emailErrors(){
            const errors = [];
            
            if (!this.$v.customer.email.$dirty) 
                return errors;

            !this.$v.customer.email.email && errors.push(this.$t('book.dialog.errors.email'));
            !this.$v.customer.email.required && errors.push(this.$t("book.dialog.errors.required"));
            
            return errors;
        }
    }
}
</script>

<style scoped>

</style>